import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';
import { IntegrationsAdvancedConfiguration } from '../../warmi/my-account/model/IntegrationsAdvancedConfiguration.models';

@Injectable({
  providedIn: 'root'
})
export class AESEncryptDecryptService {

  secretKey = environment.aesSecretKey;
  secretKeyWebSocket = environment.websocket;
  constructor() { }

  encrypt(value : string) : string{
    return CryptoJS.AES.encrypt(value, this.secretKey.trim()).toString();
  }

  decrypt(textToDecrypt : string){
    return CryptoJS.AES.decrypt(textToDecrypt, this.secretKey.trim()).toString(CryptoJS.enc.Utf8);
  }

  decryptWebSocketService(textToDecrypt : string){
    const base64 = textToDecrypt.replace(/,/g, '/').replace(/;/g, '').replace(/\*/g, '+');
    const key = CryptoJS.enc.Utf8.parse(this.secretKeyWebSocket.trim().substring(0, 8));
    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(base64)
    });
    return CryptoJS.DES.decrypt(cipherParams, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8);
  }

  getClientDataDecrypted(queryParam : string) : {clientId : string; documentNumber : string, documentType : string, name : string}| null{
      let formDataString = this.decrypt(queryParam);
      if(formDataString && typeof formDataString == "string"){
          try {
              let formData = JSON.parse(formDataString);
              return formData;
          } catch (error) {
              
          }
      }
      return null;
  }

  getCreditDataDecrypted(queryParam : string) : {creditId : string; creditCode : string}| null{
    let formDataString = this.decrypt(queryParam);
    if(formDataString && typeof formDataString == "string"){
        try {
            let formData = JSON.parse(formDataString);
            return formData;
        } catch (error) {
            
        }
    }
    return null;
  }

  getIntegrationsAdvancedConfigurationDecrypted(queryParam : string) : IntegrationsAdvancedConfiguration | null{
    let formDataString = this.decrypt(queryParam);
    if(formDataString && typeof formDataString == "string"){
        try {
            let formData = JSON.parse(formDataString);
            return formData;
        } catch (error) {
            
        }
    }
    return null;
  }

  getPaymentOrdersDataDecrypted(queryParam : string) : {paymentOrders : any[]}| null{
    let formDataString = this.decrypt(queryParam);
    if(formDataString && typeof formDataString == "string"){
        try {
            let formData = JSON.parse(formDataString);
            return formData;
        } catch (error) {
            
        }
    }
    return null;
  }

}